import Sortable from 'sortablejs';
import { Onboarding } from '@molecules/onboarding';
import { URL_USER_SETTINGS_ONBOARDING_LEADS } from '@tools/routes/routes';

export const onboarding = () => {
  function initOnboardingDragAndDrop() {
    document.querySelectorAll('.onboarding .lmc__content').forEach((element) => {
      // eslint-disable-next-line no-new
      new Sortable(element, {
        group: 'shared',
        onEnd: () => {
          document.getElementsByClassName('onboarding-content__gotit')[0].disabled = false;
        },
        ghostClass: 'lead__placeholder',
      });
    });
  }

  if (!window.BREAKPOINTS.isMobile) {
    const onboardingBehaviour = new Onboarding(URL_USER_SETTINGS_ONBOARDING_LEADS);
    onboardingBehaviour.init();
    initOnboardingDragAndDrop();
  }
};
